import { Collapse } from "@mantine/core";
import { slice } from "lodash";
import { useEffect, useState } from "react";
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";
import fetchStatVehicles from "../../../services/fetchStatVehicles";
import { pusher } from "../../..";

export default function Station({ station }: any) {
  const [opened, setOpen] = useState(false);
  const [visits, setVisits] = useState<any>([]);
  const [isLoading, setLoading] = useState(false);
  const [scanedin, setScannedin] = useState("");
  const [scanedout, setScannedout] = useState("");
  const [scanned, setScanned] = useState(true);
  const [sout, setSout] = useState(true);

  const fetchVisitsIN = async () => {
    setLoading(true);
    const data = await fetchStatVehicles(station._id);
    setVisits(data?.payload);
    setLoading(false);
  };

  const fetchVisitsOUT = async () => {
    setLoading(true);
    const data = await fetchStatVehicles(station._id);
    setVisits(data?.payload);
    setLoading(false);
  };

  useEffect(() => {
    fetchVisitsIN();
    const scan = pusher.subscribe(`visit`);
    scan.bind("in", function (data: any) {
      setScannedin(data?.payload?.vehicle);
      fetchVisitsIN();
    });

    scan.bind("out", function (data: any) {
      fetchVisitsOUT();
      setScannedout(data?.payload?.vehicle);
    });

    return () => {
      pusher.unsubscribe("visit");
    };
  }, []);

  if (isLoading) {
    return (
      <div className="col-span-12 sm:col-span-6 md:col-span-2 bg-white flex flex-col justify-start items-center border border-gray-300 rounded-md">
        <div className="text-lg p-4  border-b w-full text-gray-900 bg-white mb-2 text-center flex justify-between items-center h-16">
          <div className="truncate uppercase">{station?.name}</div>
          <div className="border-l pl-2 text-red-600 font-bold">
            {visits?.length}
          </div>
        </div>
        {opened ? (
          <Collapse
            in={opened}
            transitionDuration={1000}
            transitionTimingFunction="linear"
          >
            {/* <div className="grid grid-cols-12 gap-2  bg-white px-2">
                 {all?.map((visit: any) => (
                   <div className="col-span-12 sm:col-span-6 md:col-span-6 bg-gray-100">
                     <div className="mx-2 bg-gray-100 py-2 text-gray-800 font-bold text-sm text-center truncate">
                       {visit?.vehicle?.registration}
                     </div>
                   </div>
                 ))}
               </div> */}
          </Collapse>
        ) : (
          <div className="grid grid-cols-12 gap-2  bg-white px-2">
            {/* {few?.map((visit: any) => (
                 <div className="col-span-12 sm:col-span-6 md:col-span-6 bg-gray-100">
                   <div className="mx-2 bg-gray-100 py-2 text-gray-800 font-bold text-sm text-center truncate">
                     {visit?.vehicle?.registration}
                   </div>
                 </div>
               ))} */}
          </div>
        )}
        <div className="border-t w-full p-2 flex justify-center mt-2 bottom-0">
          <button
            onClick={() => setOpen((o) => !o)}
            className="py-2 px-8 hover:border-toyota hover:bg-red-100"
          >
            {opened ? <BsChevronCompactUp /> : <BsChevronCompactDown />}
          </button>
        </div>
      </div>
    );
  }

  let few = slice(visits, 0, 6);
  let all = visits;

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-2 bg-white flex flex-col justify-start items-center border rounded-md">
      <div className="text-lg p-4  border-b w-full text-gray-900 bg-white mb-2 text-center flex justify-between items-center h-16 rounded-t-md">
        <div className="truncate uppercase">{station?.name}</div>
        <div className="border-l pl-2 text-red-600 font-bold">
          {visits?.length}
        </div>
      </div>
      {opened ? (
        <Collapse
          in={opened}
          transitionDuration={1000}
          transitionTimingFunction="linear"
        >
          <div className="grid grid-cols-12 gap-2  bg-white px-2">
            {all?.map((visit: any) => (
              <div className="col-span-12 sm:col-span-6 md:col-span-6 bg-gray-100">
                <div className="mx-2 bg-gray-100 py-2 text-gray-800 font-bold text-sm text-center truncate">
                  {visit?.vehicle?.registration}
                </div>
              </div>
            ))}
          </div>
        </Collapse>
      ) : (
        <div className="grid grid-cols-12 gap-2  bg-white px-2">
          {few?.map((visit: any) => (
            <div className="col-span-4 sm:col-span-6 md:col-span-6 bg-gray-100">
              <div className="mx-2 bg-gray-100 py-2 text-gray-800 font-bold text-sm text-center truncate">
                {visit?.vehicle?.registration}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="border-t w-full p-2 flex justify-center mt-2 bottom-0">
        <button
          onClick={() => setOpen((o) => !o)}
          className="py-2 px-8 hover:border-toyota hover:bg-red-100"
        >
          {opened ? <BsChevronCompactUp /> : <BsChevronCompactDown />}
        </button>
      </div>
    </div>
  );
}
